/**
 * Primitivas de UI usadas en la ficha del cliente (CustomerDetail).
 *
 *  - Card: contenedor con título.
 *  - Grid: rejilla responsive de 1/2 columnas.
 *  - Field: input/display de texto en modo edición vs solo lectura.
 *  - DiscountField: input numérico 0-100 con sufijo "%".
 */

export function Card({ title, children }) {
  return (
    <div className="ds-card">
      <div className="px-4 py-3 border-b border-[#E5E5E0] font-display font-bold text-sm">
        {title}
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
}

export function Grid({ children }) {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{children}</div>;
}

export function Field({ label, value, onChange, type = "text", editing, required, span, testid }) {
  return (
    <div className={span === 2 ? "md:col-span-2" : ""}>
      <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">
        {label}
      </label>
      {editing ? (
        <input
          type={type}
          required={required}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testid}
          className="mt-1 w-full ds-card focus:border-[#6E8B3D] focus:ring-1 focus:ring-[#6E8B3D] outline-none px-3 py-2 text-sm rounded-none"
        />
      ) : (
        <div
          className="mt-1 px-3 py-2 text-sm border border-transparent bg-[#F7F7F4] min-h-[36px]"
          data-testid={testid ? `${testid}-display` : undefined}
        >
          {value || <span className="text-[#525252]">—</span>}
        </div>
      )}
    </div>
  );
}

export function DiscountField({ value, onChange, editing, testid }) {
  const display = Number(value || 0);
  return (
    <div>
      <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]" title="Descuento (%)">
        DTO%
      </label>
      {editing ? (
        <input
          type="number"
          min={0}
          max={100}
          step="0.01"
          value={value === "" || value === null || value === undefined ? "" : value}
          onChange={(e) => {
            const raw = e.target.value;
            if (raw === "") return onChange(0);
            const n = Number(raw);
            if (Number.isNaN(n)) return onChange(0);
            const clamped = Math.max(0, Math.min(100, n));
            onChange(clamped);
          }}
          data-testid={testid}
          placeholder="0"
          className="mt-1 w-full ds-card focus:border-[#6E8B3D] focus:ring-1 focus:ring-[#6E8B3D] outline-none px-3 py-2 text-sm rounded-none"
        />
      ) : (
        <div
          className="mt-1 px-3 py-2 text-sm border border-transparent bg-[#F7F7F4] min-h-[36px]"
          data-testid={testid ? `${testid}-display` : undefined}
        >
          {display > 0 ? `${display}%` : <span className="text-[#525252]">0%</span>}
        </div>
      )}
    </div>
  );
}
